import { createIcon } from '../shared'

const ChartIcon = createIcon(
  ({ color }) => (
    <path
      d="M8.75 21V3H10.75V21H8.75ZM18 21V8.5H20V21H18ZM4 21L4.004 11H6.004L6 21H4ZM13.248 21V14H15.248V21H13.248Z"
      fill={color}
    />
  ),
  '0 0 24 24',
  'TwitterChartIcon',
)

export { ChartIcon }
